import { gql } from '@apollo/client';

import { documentFragment } from '../fragments';

export default gql`
  mutation CreateDocument(
    $courseId: String!
    $subjectId: String!
    $input: CreateDocumentInput!
  ) {
    document(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(
        type: "Document"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/documents"
        method: "POST"
      ) {
      ...Document
    }
  }
  ${documentFragment}
`;
